export default __webpack_public_path__ + "static/media/sameday-assigned-icon.dd9c7aa0.svg";